var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4312_10841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4312_10841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83268 13.8337L14.7077 7.95866L13.541 6.79199L8.83268 11.5003L6.45768 9.12533L5.29102 10.292L8.83268 13.8337ZM9.99935 18.3337C8.84657 18.3337 7.76324 18.1149 6.74935 17.6774C5.73546 17.2399 4.85352 16.6462 4.10352 15.8962C3.35352 15.1462 2.75977 14.2642 2.32227 13.2503C1.88477 12.2364 1.66602 11.1531 1.66602 10.0003C1.66602 8.84755 1.88477 7.76421 2.32227 6.75033C2.75977 5.73644 3.35352 4.85449 4.10352 4.10449C4.85352 3.35449 5.73546 2.76074 6.74935 2.32324C7.76324 1.88574 8.84657 1.66699 9.99935 1.66699C11.1521 1.66699 12.2355 1.88574 13.2493 2.32324C14.2632 2.76074 15.1452 3.35449 15.8952 4.10449C16.6452 4.85449 17.2389 5.73644 17.6764 6.75033C18.1139 7.76421 18.3327 8.84755 18.3327 10.0003C18.3327 11.1531 18.1139 12.2364 17.6764 13.2503C17.2389 14.2642 16.6452 15.1462 15.8952 15.8962C15.1452 16.6462 14.2632 17.2399 13.2493 17.6774C12.2355 18.1149 11.1521 18.3337 9.99935 18.3337ZM9.99935 16.667C11.8605 16.667 13.4368 16.0212 14.7285 14.7295C16.0202 13.4378 16.666 11.8614 16.666 10.0003C16.666 8.13921 16.0202 6.56283 14.7285 5.27116C13.4368 3.97949 11.8605 3.33366 9.99935 3.33366C8.13824 3.33366 6.56185 3.97949 5.27018 5.27116C3.97852 6.56283 3.33268 8.13921 3.33268 10.0003C3.33268 11.8614 3.97852 13.4378 5.27018 14.7295C6.56185 16.0212 8.13824 16.667 9.99935 16.667Z",
    fill: "#41732F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.b845aa54e7f24406399c784dae942654.svg";
export { ForwardRef as ReactComponent };